export type TimeSeriesMeasurement = {
  time: Date;
  value: number;
};

export type TimeSeriesMeasurementPoint = {
  x: number;
  y: number;
};

export const buildSeriesData = (measurements: TimeSeriesMeasurement[]) : TimeSeriesMeasurementPoint[] =>
  measurements.map(measurement => ({
    x: new Date(measurement.time).getTime(),
    y: measurement.value
  }));